import {
  GET_INSIGHTS,
  GET_INSIGHT_DETAIL,
  GENERATE_INSIGHT,
  DELETE_INSIGHT,
  INSIGHTS_LOADING,
} from "../actions/types";

const initialState = {
  list: [],
  current: null,
  loading: false,
};

export default function insightsReducer(state = initialState, action) {
  switch (action.type) {
    case INSIGHTS_LOADING:
      return { ...state, loading: action.payload };
    case GET_INSIGHTS:
      return { ...state, list: action.payload, loading: false };
    case GET_INSIGHT_DETAIL:
      return { ...state, current: action.payload };
    case GENERATE_INSIGHT:
      return { ...state, current: action.payload, loading: false };
    case DELETE_INSIGHT:
      return {
        ...state,
        list: state.list.filter((r) => r._id !== action.payload),
        current:
          state.current && state.current._id === action.payload
            ? null
            : state.current,
      };
    default:
      return state;
  }
}
